(async () => {
    const { Core } = await importModule('Core');
    
    const addMSDays = (date, days) =>  {
        const ms = days * 86400000;
        return date + ms
    }
    
    const ATTR_TESTING_MODE = 'testing-mode';
    const LS_LAST_VIEWED = 'countryLastViewed';
    const ATTR_DISPLAY_DELAY = 'display-delay';
    const ATTR_DAYS_TO_RE_APPEAR = 'days-to-re-appear';

    customElements.define('country-popup', class extends Core {  
        
        elements = {
            content:  '[data-content]'
        }

        async render() {
            await customElements.whenDefined('modal-popup');
                let url = location.origin + '/browsing_context_suggestions.json';
                let obj = await (await fetch(url)).json();
                let country = obj.detected_values.country_name;
                if(country == "Canada"){
                    this._initPopup();
                }          
        };

        _initPopup() {
            if (this.lastViewed === null || Date.now() >= addMSDays(+this.lastViewed, this.daysToReAppear)) {
                this.lastViewed = Date.now();
                this._showPopup();
            }
        };
    
        _showPopup() {
            setTimeout(this._trigerModal.bind(this), this.displayDelay);
        };
    
        _trigerModal() {
            this.publish('modal:open', {
                target: '#countryPopup',
                backdrop: true,
                close: false,
                animation: 'fade',
                transition: 500,
                positionY: 'center',
                positionX: 'center',
            });
        };

        set lastViewed(value) {
            window.localStorage.setItem(LS_LAST_VIEWED, value);
        }

        get displayDelay() {
            return this.getAttribute(ATTR_DISPLAY_DELAY)*1000;
        }

        get lastViewed() {
            return window.localStorage.getItem(LS_LAST_VIEWED);
        }

        get daysToReAppear() {
            return +this.getAttribute(ATTR_DAYS_TO_RE_APPEAR);
        }
    });
})();